export const stringsKey = "MessageTypeSelection";
export const englishStrings = {
	voiceLabel: "Voice",
	smsLabel: "SMS",
	whatsappLabel: "WhatsApp",
	countryName: "Country",
	messageTitle: "Message Batch Name",
	messageTitleErrorText: "The Name field is required",
	countryErrorText: "The Country field is required",
	messageTypeErrorText: "Please select message type",
	messageTypeNotConfiguredErrorText:
		"The connectivity details have not been configured for this country",
	countryListErrorText: "Error loading country list, Please try again",
};
